export default "__VITE_ASSET__CUN63Icl__"